

export enum ContextViewTab {
    teachers = 'teachers',
    students = 'students',
    projects = 'projects',
    alumnus = 'alumnus',
    about = 'about',
    opa_table = 'opa',
    opa_table_month = 'opa_by_month',
}


export enum ContextViewTab {
    teachers = 'teachers',
    students = 'students',
    projects = 'projects',
    alumnus = 'alumnus',
    about = 'about',
    opa_table = 'opa',
    opa_table_month = 'opa_by_month',
}
